import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/gear',
    name: 'gear',
    component: () => import('../components/Gear')
  },
  {
    path: '/',
    name: 'discover',
    component: () => import('../components/Discover')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../components/Profile')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/Login')
  },
  {
    path: '/songs',
    name: 'songs',
    component: () => import('../components/Songs')
  },
  {
    path: '/songs/:id',
    name: 'songsDetail',
    component: () => import('../components/Song')
  },
  {
    path: '/gear/:id',
    name: 'gearDetail',
    component: () => import('../components/GearDetail')
  },
  {
    path: '/controle',
    name: 'controle',
    component: () => import('../components/Controle')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router